// features/finances/presupuestoGastosApi.ts
// PRESUPUESTO DE GASTOS (bloque B2, 15-oct-2026, Mabel). Captura en Finanzas › Presupuesto y lectura en
// Reportes › Pronóstico y presupuesto. API: /finances/presupuesto/gastos* (lib/letsmovePresupuestoGastos.js).
// Archivo aparte de api.ts a propósito (api.ts trae cambios de otras sesiones sin commitear).
import { api } from '../../services/apiClient';

export type OrigenCelda = 'desde' | 'solo' | 'heredado' | 'calculado';

export interface PGLinea {
  key: string; concept_id: number | null; user_id?: number; name: string; system_key: string | null; active: boolean;
  presupuesto: number; tienePresupuesto: boolean; origen: OrigenCelda | null; desde: string | null; note: string | null;
  real: number; n: number; diferencia: number; pct: number | null; faltaPorPagar: number;
  calculado: boolean; detalle?: string; pctComision?: number; base?: number; estimado?: boolean;
  // Pauta publicitaria (23-oct-2026): fila de grupo = suma de las pautas por clase; `hijos` = desglose (no suman aparte).
  grupo?: boolean; hijos?: PGLinea[]; hijo?: boolean; directo?: boolean; padre?: string;
  propio?: { presupuesto: number; real: number; n: number };
}
export interface PGTotales { presupuesto: number; real: number; diferencia: number; pct: number | null; faltaPorPagar: number }
export interface PGCategoria extends PGTotales { category_id: number | null; name: string; conceptos: PGLinea[] }
export interface PGSeccion extends PGTotales { section: string; label: string; categorias: PGCategoria[] }
export interface PresupuestoGastos {
  mes: string; titulo: string; enCurso: boolean; futuro: boolean; pasado: boolean;
  disponible: boolean; aviso: string | null; vacio: boolean;
  secciones: PGSeccion[]; sinConcepto: { n: number; real: number } | null;
  totales: PGTotales & { sobregiro: number; realSinPresupuesto: number; presupuestoCapturado: number; presupuestoCalculado: number };
  regla: { clave: string; texto: string }; notas: string[]; generado: string;
}

export interface PGCelda { amount: number; origen: OrigenCelda; desde?: string | null; note?: string | null;
  pct?: number; pctDelMes?: number | null; base?: number; estimado?: boolean; detalle?: string }
export interface PGFila { key: string; concept_id: number | null; user_id?: number; name: string; system_key: string | null;
  active: boolean; calculado: boolean; pctTarifa?: number; celdas: Record<string, PGCelda | null>; padre?: string }
export interface PGCuadricula {
  disponible: boolean; aviso: string | null; desde: string;
  meses: { mes: string; titulo: string; enCurso: boolean }[];
  secciones: { section: string; label: string; categorias: { category_id: number; name: string; active: boolean; conceptos: PGFila[]; totales: Record<string, number> }[] }[];
  totales: Record<string, number>; real: Record<string, number> | null; regla: { clave: string; texto: string };
}

export function getPresupuestoGastos(month: string) { return api.get<PresupuestoGastos>(`/finances/presupuesto/gastos?month=${month}`); }
export function urlExportPresupuestoGastos(month: string) { return `/api/letsmove/finances/presupuesto/gastos.xlsx?month=${encodeURIComponent(month)}`; }
export function getCuadriculaGastos(desde: string, n = 6) { return api.get<PGCuadricula>(`/finances/presupuesto/gastos/cuadricula?desde=${desde}&n=${n}`); }
export function fijarMontoGasto(b: { concept_id: number; month: string; amount: number; modo: 'desde' | 'solo'; note?: string | null }) {
  return api.put<{ ok: boolean }>('/finances/presupuesto/gastos/monto', b);
}
export function quitarMontoGasto(concept_id: number, month: string) {
  return api.del<{ ok: boolean }>(`/finances/presupuesto/gastos/monto?concept_id=${concept_id}&month=${month}`);
}
export function fijarPctComision(b: { user_id: number; month: string; pct: number | null; note?: string | null }) {
  return api.put<{ ok: boolean }>('/finances/presupuesto/gastos/comision', b);
}
export function copiarMesAnteriorGastos(month: string) {
  return api.post<{ ok: boolean; cambiados: number; desde: string }>('/finances/presupuesto/gastos/copiar', { month });
}
